import React, { useState, useEffect } from 'react'
import { experimentalStyled as styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Status from "../../../stories/StatusComponent/StatusComponent";
import { Card } from '@mui/material';
import { Margin } from '@mui/icons-material';
import axios from "../../../utils/fvAxios";
import "../../../Localization/i18n";
import { useTranslation } from "react-i18next";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

export default function StatusDescription() {
    const { t } = useTranslation();
    const [status, setStatus] = React.useState([]);
    const [error, setError] = useState(null);
    useEffect(() => {
        axios
            .get(
                "/Prequalification/GetprequalificationStatuses"
            )
            .then((res) => {
                if (res.data.responseCode === 100) {
                    setStatus(res?.data?.data?.filter((r => r.showInDashBoard)));
                } else {
                    setError(res.data.responseMessage);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    return (
        <div style={{ padding: "10px", backgroundColor: "#fff" }}>
            <p style={{ fontSize: "28px", fontWeight: "600" }}>{t("Dashboard.statusDescription")}</p>
            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={{ xs: 2, sm: 2, md: 2 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    {status?.map((r, index) => (
                        <Grid item xs={12} sm={4} md={3} lg={3} key={r.prequalificationStatusId}>
                            <Box border={1}
                                borderLeft={1}
                                borderRight={1}
                                borderColor="#e4e7ec"
                                sx={{ height: "146px", padding: "16px", paddingTop: "20px" }} >

                                {/* <span style={{backgroundColor:r.bannerColor,padding:"10px", width:"auto",borderRadius:"4px",color:"#fff"}}>{r.prequalificationStatus}</span> */}
                                <Status type={r?.prequalificationStatusId} />
                                <p style={{ marginTop: "20px", color: "#667085", fontSize: "14px" }}>{r?.prequalificationDescription}</p>
                            </Box>


                        </Grid>
                    ))}
                </Grid>
            </Box>
        </div>
    )
}
